/**
 * Created by ferto
 * Marciano Digital Agency
 * www.marciano.com.mx
 * Date: 01/02/2018.
 *
 * index Vue Store
 */
import BaseStore from '@/store/base-store'

let options = {

}

export default new BaseStore('permissions', options)



// WEBPACK FOOTER //
// ./src/store/permissions/index.js